<template>
    <div>
        <div class="dashboard-container">
            <div v-if="activityTip" style="text-align: left;position: fixed;top: 45px;">
                <img style="width: 300px;"
                    src="https://img.globalph.cn/%E5%B9%B8%E7%A6%8F%E5%B0%8F%E5%8E%A8%E5%A4%A7%E5%B1%8F2_05.png_1752199256409" />
            </div>
            <div v-if="!activityTip ||activityTip ==''" style="text-align: left;">
                <img style="width: 300px;"
                    src="https://img.globalph.cn/%E5%B9%B8%E7%A6%8F%E5%B0%8F%E5%8E%A8%E5%A4%A7%E5%B1%8F2_05.png_1752199256409" />
            </div>
            <div class="storeNameView">
                幸福小厨菜单({{dateStr}}{{timeStr}})
            </div>
            <select v-if="storeList && storeList.length>0" @focus="isFocused = true" @blur="isFocused = false" class="custom-select" v-model="storeId" v-focusable
                ref="selectRef" @change="changeStore($event.target.value)"
                style="position: fixed;right: 40px;top: 60px;width: 400px;background-color: transparent !important;direction: rtl;">
                <option v-for="item in storeList" :key="item.id" :label="item.name" :value="item.id"
                    @focus="currentFocus = item.id">{{item.name}}</option>
            </select>
            <div v-if="activityTip" class="activityTipClass">
                今日活动:{{activityTip}}
            </div>
            <div class="dishesView">
                <div class="dishItem" v-if="dishesData['SPECIAL_DISHES'] && dishesData['SPECIAL_DISHES'].length > 0">
                    <div class="dishesType">
                        <img src="https://img.globalph.cn/WechatIMG433.jpg_1752212754147" class="bg-image-type" mode="widthFix" />
                        <div class="content-type">
                            特色菜
                        </div>
                    </div>
                    <div v-for="item in dishesData['SPECIAL_DISHES']" :key="item.id">
                        <div class="dishName-special" v-if="item && item.salePrice"
                            :style="{ fontSize: item.productName.length > 6 ? '40px !important' : '50px' }"
                            :class="{ 'highlight-dish': recommendDishes.includes(item.productName) }">
                            {{item.productName || ''}}<br>
                            <div style="font-size: 30px;line-height: 30px;">({{item.salePrice || ''}}元)</div>
                        </div>
                    </div>
                </div>
                <div class="dishItem" v-if="dishesData['MAIN_MEAT'] && dishesData['MAIN_MEAT'].length > 0">
                    <div class="dishesType">
                        <img src="https://img.globalph.cn/WechatIMG432.jpg_1752200650566" class="bg-image-type"
                            mode="widthFix" />
                        <div class="content-type">
                            大荤{{dishesData['MAIN_MEAT'][0].salePrice}}元
                        </div>
                    </div>
                    <div class="dishName" v-for="item in dishesData['MAIN_MEAT']" :key="item.id"
                        :style="{ fontSize: item.productName.length > 6 ? '40px' : '50px' }"
                        :class="{ 'highlight-dish': recommendDishes.includes(item.productName) }">
                        {{item.productName || ''}}
                    </div>
                </div>
                <div class="dishItem" v-if="dishesData['SIDE_MEAT'] && dishesData['SIDE_MEAT'].length > 0">
                    <div class="dishesType">
                        <img src="https://img.globalph.cn/WechatIMG432.jpg_1752200650566" class="bg-image-type"
                            mode="widthFix" />
                        <div class="content-type">
                            小荤{{dishesData['SIDE_MEAT'][0].salePrice}}元
                        </div>
                    </div>
                    <div class="dishName" v-for="item in dishesData['SIDE_MEAT']" :key="item.id"
                        :style="{ fontSize: item.productName.length > 6 ? '40px' : '50px' }"
                        :class="{ 'highlight-dish': recommendDishes.includes(item.productName) }">
                        {{item.productName || ''}}
                    </div>
                </div>
                <div class="dishItem" v-if="dishesData['VEGETABLE'] && dishesData['VEGETABLE'].length > 0">
                    <div class="dishesType">
                        <img src="https://img.globalph.cn/WechatIMG432.jpg_1752200650566" class="bg-image-type"
                            mode="widthFix" />
                        <div class="content-type">
                            素菜{{dishesData['VEGETABLE'][0].salePrice}}元
                        </div>
                    </div>
                    <div class="dishName" v-for="item in dishesData['VEGETABLE']" :key="item.id"
                        :style="{ fontSize: item.productName.length > 6 ? '40px' : '50px' }"
                        :class="{ 'highlight-dish': recommendDishes.includes(item.productName) }">
                        {{item.productName || ''}}
                    </div>
                </div>
                <div class="dishItem" v-if="dishesData['RICE'] || dishesData['SOUP']">
                    <div class="dishesType">
                        <img src="https://img.globalph.cn/WechatIMG432.jpg_1752200650566" class="bg-image-type"
                            mode="widthFix" />
                        <div class="content-type">
                            汤品/主食
                        </div>
                    </div>
                    <div class="dishName" v-for="item in dishesData['SOUP']" :key="item.id"
                        :style="{ fontSize: item.productName.length > 6 ? '40px' : '50px' }"
                        :class="{ 'highlight-dish': recommendDishes.includes(item.productName) }">
                        {{item.productName || ''}}{{(!item.salePrice || item.salePrice==0)?'免费':(item.salePrice + 元)}}
                    </div>
                    <div class="dishName" v-for="item in dishesData['RICE']" :key="item.id"
                        :style="{ fontSize: item.productName.length > 6 ? '40px' : '50px' }"
                        :class="{ 'highlight-dish': recommendDishes.includes(item.productName) }">
                        {{item.productName || ''}}{{item.salePrice}}元
                    </div>
                    <!-- <div class="dishName">
                        米饭1元
                    </div> -->
                </div>
               
            </div>
            <div class="bottomView">
                <div class="left"
                    style="float: left;width: 740px;;height: 330px;margin-right: 20px;border-radius: 32px;overflow: hidden;;border: 2px solid rgb(255, 220, 125);"
                    v-if="firstAdvUrl && firstAdvUrl.url">
                    <img :src="firstAdvUrl.url" style="border-radius:30px;height: 100%;width: 100%;" fit="fill" />
                </div>
                <div class="left"
                    style="float: left;width: 740px;;height: 330px;margin-right: 20px;border-radius: 32px;overflow: hidden;border: 2px solid rgb(255, 220, 125);"
                    v-if="bannerData && bannerData.length > 0">
                    <!-- <Swiper :modules="modules" :slides-per-view="1" :loop="true"
                        :autoplay="{ delay: 5000, disableOnInteraction: false }" v-if="showBanner">
                        <SwiperSlide v-for="item in bannerData" :key="item.id">
                            <img :src="item.url" fit="fill" style="height: 100%;width: 100%;" />
                        </SwiperSlide>
                    </Swiper> -->
                    <swiper v-if="bannerData.length > 0" :options="swiperOptions" ref="mySwiper">
                        <swiper-slide v-for="(item, index) in bannerData" :key="index">
                            <img :src="item.url" fit="fill" style="height: 100%;width: 100%;" />
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="right"
                    style="height: 330px;width: 275px;text-align: center;border-radius:30px;float: left;overflow: hidden;">
                    <div style="width: 275px;height: 330px;">
                        <img v-if="wxCodeData && wxCodeData.length>0" :src="wxCodeData[0].url"
                            style="height: 330px;width: 275px;" fit="fill" />
                    </div>
                </div>
            </div>   
        </div>
        <CozeChat 
            v-if="!useApiChat" 
            ref="cozeChatRef" 
            :visible="chatVisible" 
            @close="hideChatDialog" 
            :customer_name="'客户'"
            :customer_id="storeId ? storeId.toString() : '10082'"
        />
        <CozeApiChat 
            v-else
            ref="cozeApiChatRef" 
            :visible="chatVisible" 
            @close="hideChatDialog" 
            :customer_name="'客户'"
            :customer_id="storeId ? storeId.toString() : '10082'"
        />
    </div>
</template>

<script>
    import { getUserStoresWithTenantId, getStoreDetail, getStoreCategoryMedias, getDayDishes } from '@/api/requestApi'
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    import CozeChat from '@/components/CozeChat.vue'
    import CozeApiChat from '@/components/CozeApiChat.vue'
    import { SOCKET_BASE_URL } from '@/utils/config'
    export default {
        components: {
            Swiper,
            SwiperSlide,
            CozeChat,
            CozeApiChat
        },
        name: 'storeDashboard',
        created() {
            console.log('created')
            this.checkBrowserCompatibility();
            this.loadData()
        },
        beforeDestroy() {
            this.clearTimer();
            // 关闭 WebSocket 连接
            this.closeWebSocket();
            // 停止ping定时器
            this.stopPing();
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.$swiper
            }
        },
        mounted() {
             // 监听遥控器确认键
            document.addEventListener('keydown', e => {
                console.log('keydown', e.keyCode,this.isFocused)
                console.log('chatVisible',this.chatVisible)
                if(e.keyCode == 37 && this.chatVisible){
                    if (this.useApiChat && this.$refs.cozeApiChatRef) {
                        this.$refs.cozeApiChatRef.closeDialog();
                    }
                
                }
                else if ((e.keyCode === 13 || e.keyCode === 40) && !this.isFocused && this.$refs.selectRef) {
                    this.$refs.selectRef.focus(); 
                    this.$refs.selectRef.click();
                } 
            });
        },
        data() {
            return {
                isFocused:false,
                selectedValue: '',
                title:'12345',
                dateStr:'',
                storeId:null,
                timeStr:'午餐',
                storeInfo:{},
                dishesData:{},
                bannerData:[],
                firstAdvUrl:null,
                wxCodeData:null,
                storeList:[],
                showBanner:false,
                timerId: null,      
                timerStatus: '未启动',
                activityTip:'',
                timer:null,
                swiperOptions: {
                    loop: true, // 循环播放
                    autoplay: { delay: 5000 }, // 3秒自动切换
                    pagination: { el: '.swiper-pagination', clickable: true },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },

                chatVisible:true,
                useApiChat: false, // 默认使用SDK版本，旧浏览器使用API版本
                
                // WebSocket 相关属性
                websocket: null,
                websocketUrl: 'ws://uat.n.b2b.globalph.cn/cozeAIWs?storeId=39',
                reconnectInterval: 5000, 
                maxReconnectAttempts: 10, 
                reconnectAttempts: 0, 
                isManuallyClosed: false, 
                recommendDishes:[],
                tempRecommendDishesStr:'',
                pingInterval: null // 用于存储ping定时器
            }
        },
        methods: {
            // 检测浏览器兼容性
            checkBrowserCompatibility() {
                // 检测是否支持现代浏览器特性
                const isModernBrowser = (
                    typeof Promise !== 'undefined' &&
                    typeof fetch !== 'undefined' &&
                    typeof Array.from !== 'undefined' &&
                    typeof Object.assign !== 'undefined'
                );
                
                // 检测是否为旧版本浏览器（如IE或老版本Android浏览器）
                var isOldBrowser = this.isOldBrowser();
                isOldBrowser = true

                // 检测是否支持WebSocket（用于实时通信）
                const supportsWebSocket = typeof WebSocket !== 'undefined';
                
                // 检测是否支持ES6特性
                const supportsES6 = (
                    typeof Symbol !== 'undefined' &&
                    typeof Map !== 'undefined' &&
                    typeof Set !== 'undefined'
                );
                
                // 综合判断是否为现代浏览器
                const isCompatibleBrowser = isModernBrowser && supportsWebSocket && supportsES6;
                
                // 在旧浏览器中使用API版本
                if (isOldBrowser || !isCompatibleBrowser) {
                    console.log('检测到旧版或不兼容浏览器，使用API版本聊天组件');
                    this.useApiChat = true;
                } else {
                    console.log('检测到现代浏览器，使用SDK版本聊天组件');
                    this.useApiChat = false;
                }
                
                // 输出浏览器信息用于调试
                console.log('浏览器兼容性检测结果:', {
                    isModernBrowser,
                    isOldBrowser,
                    supportsWebSocket,
                    supportsES6,
                    isCompatibleBrowser,
                    useApiChat: this.useApiChat
                });
            },
            
            // 判断是否为旧浏览器
            isOldBrowser() {
                // 检测用户代理字符串
                const ua = navigator.userAgent;
                
                // 检测IE浏览器
                if (ua.indexOf('MSIE') !== -1 || ua.indexOf('Trident') !== -1) {
                    return true;
                }
                
                // 检测老版本Android浏览器（4.4及以下）
                const androidVersionMatch = ua.match(/Android\s([0-9.]+)/);
                if (androidVersionMatch && androidVersionMatch[1]) {
                    const version = parseFloat(androidVersionMatch[1]);
                    if (version <= 4.4) {
                        return true;
                    }
                }
                
                // 检测老版本iOS Safari（8及以下）
                const iosVersionMatch = ua.match(/OS\s(\d+)_/);
                if (iosVersionMatch && iosVersionMatch[1]) {
                    const version = parseInt(iosVersionMatch[1]);
                    if (version <= 8) {
                        return true;
                    }
                }
                
                return false;
            },
            
            loadData(){
                console.log('init')
                this.title = 'test222'
                var  today = new Date();
                var month = today.getMonth() + 1;
                var day = today.getDate();
                this.dateStr = `${month}月${day}日`;
                var storeStoreId = window.localStorage.getItem('BigScreenStoreId') ? parseInt(window.localStorage.getItem('BigScreenStoreId')) : null
                console.log('storeStoreId', storeStoreId)
                if (storeStoreId) {
                    this.storeId = parseInt(storeStoreId)
                    this.websocketUrl = `${SOCKET_BASE_URL}?storeId=${this.storeId}`
                    this.startTimer()
                    this.refresh()
                } else {
                    this.getStoreList()
                }
                this.initWebSocket()
                // setTimeout(() => {
                //     this.handleActivityTipClick()
                // }, 2000);
            },
             // 启动定时器
            startTimer() {
                if (this.timerId) return; // 避免重复启动
                this.timerStatus = '运行中';

                // 设置20分钟定时任务
                this.timerId = setInterval(() => {
                    this.executeTask();   // 执行核心任务
                }, 1200000);            // 20分钟 = 1,200,000毫秒÷
            },

            // 定时任务逻辑
            executeTask() {
                console.log("定时任务执行 - " + new Date().toLocaleTimeString());
                // 实际业务逻辑示例：
                console.log('executeTask')
            },

            // 清除定时器
            clearTimer() {
                if (this.timerId) {
                    clearInterval(this.timerId);
                    this.timerId = null;   // 清除ID引用防止内存泄漏
                    this.timerStatus = '已停止';
                }
            },
            
            // 初始化 WebSocket 连接
            initWebSocket() {
                // 如果是手动关闭的连接，不再重连
                if (this.isManuallyClosed) {
                    return;
                }
                
                try {
                    // 创建 WebSocket 连接
                    this.websocket = new WebSocket(this.websocketUrl);
                    
                    // 连接成功回调
                    this.websocket.onopen = () => {
                        console.log('WebSocket 连接成功:', this.websocketUrl);
                        // 重置重连次数
                        this.reconnectAttempts = 0;
                        
                        // 启动定时发送ping消息，每30秒一次
                        this.startPing();
                    };
                    
                    // 接收消息回调
                    this.websocket.onmessage = (event) => {
                        try {
                            // 解析接收到的消息
                            // const data = JSON.parse(event.data);
                            const data = event.data;
                            // 检查是否包含菜单推荐信息
                            
                            console.log('WebSocket 接收到消息:', data);
                            const customerId = '0'
                            var message = {
                                role: 'assistant',
                                content: data,
                                contentType: 'text',
                                isStreaming:true
                            };
                            this.tempRecommendDishesStr += data
                            if(data == 'done'){
                                message = {
                                    role: 'assistant',
                                    content: '',
                                    contentType: 'text',
                                    isComplete: true
                                };
                                if (this.tempRecommendDishesStr.includes('为您推荐今日菜品：')) {
                                    console.log('包含推荐菜单:', this.tempRecommendDishesStr);
                                    try {
                                        // 改进的推荐菜品解析逻辑，支持多种分隔符
                                        const match = this.tempRecommendDishesStr.match(/为您推荐今日菜品："([^"]+)"/);
                                        console.log('match--', match)
                                        if (match && match[1]) {
                                            const dishesStr = match[1];
                                            console.log('dishesStr', dishesStr)
                                            // 使用多种分隔符来分割菜品，包括中文逗号、英文逗号和顿号
                                            this.recommendDishes = dishesStr.split(/[，,、]/).map(item => item.trim()).filter(item => item.length > 0);
                                            
                                            console.log('更新推荐菜品:', this.recommendDishes);
                                            this.tempRecommendDishesStr = ''
                                        } else {
                                            console.warn('未能正确匹配推荐菜单格式');
                                            this.recommendDishes = [];
                                        }
                                    } catch (parseError) {
                                        console.error('解析菜单推荐失败:', parseError);
                                        this.recommendDishes = [];
                                        this.tempRecommendDishesStr = ''
                                    }
                                }

                            }

                            // 调用 CozeApiChat 组件的 addExternalMessage 方法显示消息
                            if (this.useApiChat && this.$refs.cozeApiChatRef) {
                                this.$refs.cozeApiChatRef.addExternalMessage(message, customerId);
                            }
                            // 检查消息类型
                            if (data.type === 'chat') {
                                // 如果是聊天消息类型，直接传递给 CozeApiChat 组件显示
                                // const message = {
                                //     role: data.role || 'assistant',
                                //     content: data.content,
                                //     contentType: data.contentType || 'text'
                                // };
                                // 提取 customerId（如果有的话）
                                // const customerId = '0'
                                // const message = {
                                //     role: 'assistant',
                                //     content: data.content,
                                //     contentType: 'text'
                                // };
                                
                                
                                // // 调用 CozeApiChat 组件的 addExternalMessage 方法显示消息
                                // if (this.useApiChat && this.$refs.cozeApiChatRef) {
                                //     this.$refs.cozeApiChatRef.addExternalMessage(message, customerId);
                                // }
                            } else {
                                // 其他类型的消息，提取 customerId 并调用 handleSendMessageAction 方法
                                const customerId = data.customerId;
                                if (customerId) {
                                    this.handleSendMessageAction(customerId);
                                }
                            }
                        } catch (error) {
                            console.error('解析 WebSocket 消息失败:', error);
                        }
                    };
                    
                    // 连接错误回调
                    this.websocket.onerror = (error) => {
                        console.error('WebSocket 连接出错:', error);
                        this.reconnectWebSocket();
                    };
                    
                    // 连接关闭回调
                    this.websocket.onclose = () => {
                        console.log('WebSocket 连接已关闭');
                        this.reconnectWebSocket();
                    };
                } catch (error) {
                    console.error('初始化 WebSocket 连接失败:', error);
                    this.reconnectWebSocket();
                }
            },
            
            // 断线重连
            reconnectWebSocket() {
                // 如果是手动关闭的连接，不再重连
                if (this.isManuallyClosed) {
                    return;
                }
                
                // 检查是否超过最大重连次数
                if (this.reconnectAttempts >= this.maxReconnectAttempts) {
                    console.error('WebSocket 重连次数已达上限');
                    return;
                }
                
                // 增加重连次数
                this.reconnectAttempts++;
                
                // 延迟重连
                setTimeout(() => {
                    console.log(`尝试第 ${this.reconnectAttempts} 次重连 WebSocket`);
                    this.initWebSocket();
                }, this.reconnectInterval);
            },
            
            // 启动定时发送ping消息
            startPing() {
                // 先清除已存在的定时器
                this.stopPing();
                
                // 每30秒发送一次ping消息
                this.pingInterval = setInterval(() => {
                    if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
                        this.websocket.send('ping');
                        console.log('发送ping消息以保持WebSocket连接活跃');
                    }
                }, 30000); // 30秒
            },
            
            // 停止定时发送ping消息
            stopPing() {
                if (this.pingInterval) {
                    clearInterval(this.pingInterval);
                    this.pingInterval = null;
                }
            },
            
            // 关闭 WebSocket 连接
            closeWebSocket() {
                // 标记为手动关闭
                this.isManuallyClosed = true;
                
                // 停止发送ping消息
                this.stopPing();
                
                // 关闭连接
                if (this.websocket) {
                    this.websocket.close();
                }
            },
            
            // 处理发送消息动作
            handleSendMessageAction(customerId) {
                console.log('处理发送消息动作，customerId:', customerId);
                // 调用现有的 handleActivityTipClick 方法
                this.handleActivityTipClick(customerId);
            },
            refresh() {
                console.log('refresh --- 刷新数据')
                this.getDetail()
                this.getDishes()
                this.getBannerData()
                this.getWxCodeData()
                this.getStoreList()
                
                // 重新连接 WebSocket
                this.closeWebSocket();
                // 重置手动关闭标记，允许重新连接
                this.isManuallyClosed = false;
                // 重置重连次数
                this.reconnectAttempts = 0;
                // 初始化新的 WebSocket 连接
                this.initWebSocket();
            },
            async getStoreList() {
                const data = await getUserStoresWithTenantId('931f161f7f4e11ed9c02b8599f37731c')
                if (data.success) {
                    this.storeList = data.obj
                    if (!this.storeId) {
                        this.storeId = data.obj[0].id
                        this.websocketUrl = `${SOCKET_BASE_URL}?storeId=${this.storeId}`
                        this.refresh()
                    }
                    // this.$nextTick(() => {
                    //     const element = this.$refs.selectRef
                    //     if (element) { 
                    //         element.focus();
                    //     } else {
                    //         console.error("元素未找到！")
                    //     }
                    // });
                }
            },
            async getDetail() {
                getStoreDetail(this.storeId).then(res => {
                    if (res.success) {
                        this.storeInfo = res.obj
                    }
                })
            },
            async getBannerData() {
                this.bannerData = []
                this.showBanner = false
                this.firstAdvUrl = null
                getStoreCategoryMedias(this.storeId, 'DISH_BIG_SCREEN_BANNER').then(res => {
                    if (res.success) {
                        if (res.obj && res.obj.length > 0) {
                            var arr = res.obj
                            this.firstAdvUrl = arr[0]
                            var rest = arr.slice(1)
                            this.bannerData = rest.length === 2 ? [...rest, ...rest] : rest
                            setTimeout(() => {
                                this.showBanner = true
                            }, 200);
                        }
                    }
                })
            },
            async getWxCodeData() {
                this.wxCodeData = null
                getStoreCategoryMedias(this.storeId, 'DISH_BIG_SCREEN_BUTLER_WX_CODE').then(res => {
                    if (res.success) {
                        this.wxCodeData = res.obj
                    }
                })
            },
            async getDishes() {
                var params = {
                    "tenantId": "931f161f7f4e11ed9c02b8599f37731c",
                    "storeId": this.storeId
                }
                this.dishesData = {}
                this.activityTip = null
                getDayDishes(params).then(res => {
                    if (res.success) {
                        if (this.isAfternoon() && res.obj['DINNER'] && res.obj['DINNER']['MAIN_MEAT']) {
                           this. dishesData = res.obj['DINNER']
                           this.timeStr = '晚餐'
                        } else if (res.obj['LUNCH']) {
                            this.dishesData = res.obj['LUNCH']
                            this.timeStr = '午餐'
                        }
                        if(!this.dishesData['RICE'] || this.dishesData['RICE'].length == 0){
                           console.log('没有rice')
                           this.dishesData['RICE'] = [{
                                "productName": "米饭",
                                "salePrice": 1
                           }]
                        }
                        if(!this.dishesData['SOUP'] || this.dishesData['SOUP'].length == 0){
                           this.dishesData['SOUP'] = [{
                                "productName": "例汤",
                                "salePrice": 0
                           }]
                        }
                        console.log('dishesData', this.dishesData)
                        if (this.dishesData['SPECIAL_DISHES']) {
                            var tipArray = this.dishesData['SPECIAL_DISHES'].filter((item) => {
                                return item.salePrice == null || item.salePrice == ''
                            })
                            if (tipArray.length > 0) {
                                this.activityTip = tipArray[0].productName
                            }
                        }
                        console.log('activityTip.value', this.activityTip)
                    }
                })
            },
            changeStore(item) {
                console.log('changeStore', item)
                this.currentFocus = item
                window.localStorage.setItem('BigScreenStoreId', item)
                // 更新 WebSocket URL
                this.websocketUrl = `${SOCKET_BASE_URL}?storeId=${item}`
                this.refresh()
            },
            isAfternoon() {
                const now = new Date();
                const currentHour = now.getHours();
                return currentHour >= 13;
            },
            hideChatDialog() {
                this.chatVisible = false
                this.recommendDishes = []
            },
            handleActivityTipClick(customerId) {
                console.log('handleActivityTipClick 触发')
                
                try {
                    // 根据使用的聊天组件类型调用相应的方法
                    if (!this.useApiChat && this.$refs.cozeChatRef) {
                        // 使用SDK版本
                        console.log('cozeChatRef存在，调用createNewChat方法')
                        this.$refs.cozeChatRef.createNewChat()
                    } else if (this.useApiChat && this.$refs.cozeApiChatRef) {
                        // 使用API版本的新方法
                        console.log('cozeApiChatRef存在，调用showAndSendMessage方法')
                        // 示例：发送预定义消息并传入当前storeId作为customerId
                        const content = "理疗";
                        const customerId1 = customerId || '10082';
                        this.$refs.cozeApiChatRef.showAndSendMessage(content, customerId1);
                    } else {
                        console.error('聊天组件引用不存在，无法创建新对话框')
                        // 作为备选方案，直接设置chatVisible
                        this.chatVisible = true
                    }
                } catch (error) {
                    console.error('调用聊天组件方法失败:', error)
                    // 出错时作为备选方案，直接设置chatVisible
                    this.chatVisible = true
                }
            }
        }

    }
</script>

<style scoped>

.dashboard-container {
    background-color: #f44423;
    /* background-color: #000000; */
    width: 1920px;
    height: 1080px;
    padding-top: 20px;
    padding-left: 50px;
    padding-right: 50px;
    font-weight: 500;
    /* font-family: '方正兰亭粗黑', serif; */
}

.storeNameView {
    color: rgb(255, 245, 193);
    text-align: center;
    font-size: 80px;
    font-weight: 500;
    /* font-family: '方正兰亭大黑简体', serif !important; */
}

.dishesView {
    margin-top: 10px;
    text-align: center;
    min-height: 450px;
    color: white;
}

.dishesView {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(285px, 1fr));
    justify-content: center;
    width: 1820px;
}

.dishItem {
    padding: 10px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* border: 1px solid #ddd;  */
}

.dishesType {
    position: relative;
    width: 285px;
    height: 80px;
    overflow: hidden;
    color: white;
    margin-bottom: 30px;
}

.bg-image-type {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3;
}

.content-type {
    position: relative;
    z-index: 4;
    width: 100%;
    height: 100%;
    font-size: 50px;
    text-align: center;
    line-height: 80px;
    color: rgb(241, 61, 29);
}

.dishName {
    font-size: 50px;
    text-align: center;
    color: rgb(254, 247, 238);
    margin-bottom: 10px;
}

.highlight-dish {
    color: #ffd900 !important; /* 金色 */
    text-shadow: 0 0 10px rgba(255, 215, 0, 0.5); /* 发光效果 */
    font-weight: bold;
    transform: scale(1.05); /* 稍微放大 */
    position: relative;
    padding-right: 60px; /* 为图标预留空间(50px图标宽度 + 10px右侧间距) */
    overflow: visible; /* 允许内容溢出 */
}

.highlight-dish::after {
    content: "";
    position: absolute;
    right: 5px; /* 距离右边5px，与文字保持5px间距 */
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    background-image: url("../assets/recommend.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10; /* 确保图标在最上层 */
    pointer-events: none; /* 防止图标阻挡点击事件 */
}

.dishName-special {
    /* font-size: 50px; */
    text-align: center;
    color: rgb(255, 220, 125);
    line-height: 1.1;
    margin: 0;
    margin-bottom: 10px;
}
.activityTipClass {
    /* font-size: 50px; */
    text-align: center;
    color: rgb(255, 220, 125);
    line-height: 1.1;
    margin: 0;
    font-size: 60px;
}

.bottomView {
    height: 330px;
}



.store-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* align-items: center;        */
    height: 330px;
    color: white;
    font-size: 40px;
}

.store-container-item {
    margin: 5px;
}


.custom-select {
    /* 隐藏边框 */
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    
    /* 文字样式 */
    color: white !important; /* 文字白色 */
    font-size: 30px !important; /* 字体大小 30px */
    text-align: right !important; 
    text-align-last: right !important;
    padding-right: 30px !important; /* 为箭头预留空间 */
    
    /* 隐藏默认箭头 */
    appearance: none !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    
    /* 自定义白色箭头（SVG） */
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 20px;
    
    /* 背景透明（可选） */
    background-color: transparent;
}

/* 移除聚焦时的默认蓝框 */
.custom-select:focus {
    outline: none !important;
}
.swiper-container {
  width: 100%;
  height:100%; /* 必须指定高度 */
}
</style>